module.exports = __webpack_public_path__ + "static/media/logo.8fb2f26d.svg";